export const translation = {
    targets: {
        COLUMN: '$t(glossary:column)',
        SOURCE_LOCATION: '$t(glossary:schema)',
        DATASET: '$t(glossary:dataset)',
        SPACE: '$t(glossary:project)'
    },
    types: {
        ShortText: 'Short Text',
        LongText: 'Multi-line Text',
        Selection: 'Single-Select (Dropdown)',
        Boolean: 'Boolean'
    },
    Configure: {
        title: 'Configure Property',
        defaultValue: {
            label: 'Default Text (Optional)',
            placeholder: 'Enter text…',
            charsWarning: 'Default value can only consist of the following characters. A-Z, a-z, 0-9, dash, and underscore (_). Names cannot begin with an underscore or a space and cannot end with a space.',
            charsWarningLong: 'Default value can only consist of the following characters. A-Z, a-z, 0-9, dash, and underscore (_). Values cannot begin with an underscore or a space and cannot end with a space.'
        },
        option: {
            charsWarning: 'Option value can only consist of the following characters. A-Z, a-z, 0-9, dash, and underscore (_). Names cannot begin with an underscore or a space and cannot end with a space.'
        },
        valuesLabel: 'Values',
        target: {
            label: 'Property should be used in',
            placeholder: 'Select asset…',

            requiredWarning: 'Please specify a target for the property.'
        },
        name: {
            label: 'Property name',
            placeholder: 'Enter name…',
            charsWarning: 'Attribute names can only consist of the following characters. A-Z, a-z, 0-9, dash, and underscore (_). Names cannot begin with an underscore or a space and cannot end with a space.',
            requiredWarning: 'Please provide a name for the property.',
            lengthWarning: 'Sorry, names can only be 100 characters long.'
        },
        type: {
            label: 'Field Type',
            placeholder: 'Select Type…'
        }
    },
    Hints: {
        default: 'Default',
        unknown: 'unknown',
        defaultHint: 'The selection of a default value is optional. If a default is selected ‘None’ is no longer an option. If required it needs to be manually added as a value.'
    },
    emptyValue: 'None',
    true: 'true',
    false: 'false'
};
